import axios from 'axios';

import cfac22 from '../cfac22';

export function apiConsumeVoucher(uId, triiboId, storeId) {
  return new Promise(function (resolve, reject) {
    Promise.resolve().
    then(() => {
      axios.
      post(
        cfac22('API_HOST_V2') + '/vouchers/consumeVoucher',
        {
          triiboId,
          storeId
        },
        {
          headers: { 'Full-Url': window.location.href }, withCredentials: true
        }
      ).
      then((result) => {
        resolve(result.data);
      }).
      catch((error) => {
        reject(error.response.data);
      });
    }).
    catch((errorToken) => {
      reject(errorToken);
    });
  });
}
